import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-address",
  "use": "icon-address-usage",
  "viewBox": "0 0 12.36 13.63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.36 13.63\" id=\"icon-address\"><defs><style>#icon-address .cls-1{fill:none;stroke:#999;stroke-miterlimit:10;}</style></defs><title>资源 148</title><g id=\"icon-address_图层_2\" data-name=\"图层 2\"><g id=\"icon-address_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M6.18,13.13c-.79,0-5.68-3.81-5.68-7a5.68,5.68,0,0,1,11.36,0c0,3.14-4.89,7-5.68,7Zm0-5.21A1.74,1.74,0,1,0,4.45,6.18,1.74,1.74,0,0,0,6.18,7.92Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol